<template>
    <div class="guide">
        <div class="guide-content">
            <!-- 非正式会员 -->
            <div
                v-if="guideType !== 1 && routerName === 'lawservice' && vipInfo && vipInfo.vipStatusName !== 'vip' "
                v-visually="{
                    serverId: 17096,
                    area: 'btn-ljqyxf',
                }"
                class="wise-guide right"
                @click="handleAuthorize"
            >
                <div class="wise-guide-icon"></div>
                <p class="wise-guide-txt">了解会员权益</p>
                <div class="line"></div>
            </div>
            <div
                v-if="guideType !== 1 && isShowFeedBack"
                class="wise-guide feed-back"
                @click="clickFeedBack"
            >
                <div class="wise-guide-icon"></div>
                <p class="wise-guide-txt">用户</p>
                <p class="wise-guide-txt">反馈</p>
                <div class="line"></div>
            </div>
            <!-- 用户反馈 -->
            <div
                v-if="isAgentPage"
                class="wise-guide service-number-box agent-box"
                @mouseenter="showAgentCard"
                @mouseleave="hideAgentCard"
            >
                <div class="wise-guide-icon agent-icon"></div>
                <p class="wise-guide-txt">问题</p>
                <p class="wise-guide-txt">反馈</p>
                <div
                    v-if="isShowAgentModal"
                    ref="service-number-card"
                    class="guide-card service-number-card"
                >
                    <p class="card-title">智能体问题反馈群</p>
                    <p class="card-text">请用微信扫码进群</p>
                    <div
                        class="card-qrcode-box"
                    >
                        <div
                            class="qrcode"
                            :style="{backgroundImage: `url(https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/feedback.png)`}"
                        ></div>
                    </div>
                </div>
                <div class="line"></div>
            </div>
            <!-- 律临服务号 -->
            <div
                class="wise-guide service-number-box"
                @mouseenter="showServiceNumberCard"
                @mouseleave="hideServiceNumberCard"
            >
                <div class="wise-guide-icon service-number-icon"></div>
                <p class="wise-guide-txt">律临</p>
                <p class="wise-guide-txt">服务号</p>
                <div
                    v-if="+guideType === 1 || isShowServiceNumberModal"
                    ref="service-number-card"
                    class="guide-card service-number-card"
                >
                    <p class="card-title">百度律师服务号</p>
                    <p class="card-text">便捷服务通知反馈接收平台</p>
                    <div
                        class="card-qrcode-box"
                    >
                        <div
                            class="qrcode"
                            :style="{backgroundImage: `url(https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/lvlin-service-img.jpg)`}"
                        ></div>
                    </div>
                    <!-- 任务引导-关注 -->
                    <div
                        v-if="+guideType === 1"
                        class="guide-msg-box"
                    >
                        <div class="guide-msg">微信扫码，关注服务号并完成绑定，即可完成任务</div>
                        <div class="confirm-btn" @click="onServiceConfirm">我知道了</div>
                    </div>
                </div>
                <div v-if="guideType !== 1" class="line"></div>
            </div>
            <!-- 律临小程序 -->
            <div
                v-if="guideType !== 1"
                class="wise-guide"
                @mouseenter="showGuideCard"
                @mouseleave="hideGuideCard"
            >
                <div class="wise-guide-icon"></div>
                <p class="wise-guide-txt">律临</p>
                <p class="wise-guide-txt">移动端</p>

                <div
                    v-if="isShowGuideCard"
                    class="guide-card"
                >
                    <p class="guide-title">律师微信小程序</p>
                    <p class="guide-txt">查号码、领线索</p>
                    <div class="guide-qrcode-wrap">
                        <div class="guide-qrcode"></div>
                    </div>
                    <p
                        class="guide-txt watch-guide"
                        @click="watchGuide"
                    >添加律临到手机桌面</p>
                </div>
            </div>
            <vip-authorize-modal
                :show="isShowAuthorizeSucc"
                :authorized="true"
                @cancel="isShowAuthorizeSucc = false"
            />
        </div>
        <div
            v-if="isShowMask"
            class="mask-box"
            @click.self="hideMask"
        ></div>
    </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import {authorize} from '../utils/commonReq';
import VipAuthorizeModal from '../components/vip/vip-authorize-modal.vue';

const URL = {
    getqrticket: '/bp/api/wechat/getqrticket'
};

export default {
    name: 'wiseGuide',
    data() {
        return {
            isShowGuideCard: false,
            isShowServiceNumberModal: false,
            routerName: '',
            isSubmitting: false,
            serviceNumberTicket: '',
            // 展示授权成功弹窗
            isShowAuthorizeSucc: false,
            isShowAgentModal: false
        };
    },
    components: {
        'vip-authorize-modal': VipAuthorizeModal
    },
    computed: {
        ...mapState({
            vipInfo: state => state.lawStore.vipInfo,
            userRole: state => state.lawStore.userInfoNew && state.lawStore.userInfoNew.user_role,
            guideType: state => +state.lawStore.guideType
        }),
        isShowFeedBack() {
            let feedbackPages = [
                'lawclues',
                'offlineQa',
                'consult',
                'lawquestion',
                'qaManage',
                'caseManage',
                'courseCenter',
                'AIContract',
                'dataCenter'
            ];
            let isShow = feedbackPages.includes(this.routerName);
            if (isShow) {
                this.$wywLog.send({
                    serverId: 17144,
                    area: 'btn-fkrk',
                    action: 'show'
                });
            }
            return isShow;
        },
        // 律临服务号入口-是否展现
        isShowServiceNumberEntry() {
            this.$wywLog.send({
                serverId: 17144,
                area: 'fwh-fo-entrance',
                action: 'show'
            });
            return false;
        },
        lawyerServiceQrCode() {
            return 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + this.serviceNumberTicket;
        },
        isShowMask() {
            return +this.guideType === 1;
        },
        isAgentPage() {
            let pages = ['roleSet', 'repositoryManage'];
            return pages.includes(this.$route.name);
        }
    },
    watch: {
        // 暂时不用了，产品交互修改
        // userRole: {
        //     handler(val) {
        //         // 律师
        //         if (val === 0) {
        //             this.getQrTicket();
        //         }
        //     },
        //     deep: true
        // },
        guideType: {
            handler(val) {
                // 任务场景
                if (+val === 1) {
                    this.$wywLog.send({
                        serverId: 17144,
                        area: 'fwh-qrcoed',
                        action: 'show',
                        scene: 1
                    });
                }
            },
            deep: true
        }
    },
    created() {
        this.routerName = this.$route.name;
        this.$router.afterEach(to => {
            this.routerName = to.name || '';
        });
    },
    methods: {
        ...mapMutations({
            setGuideType: 'lawStore/setGuideType'
        }),
        showGuideCard() {
            if (this.isShowGuideCard) {
                return;
            }
            this.isShowGuideCard = true;
            this.$wywLog.send({
                serverId: 17012,
                area: 'qrcode-show',
                action: 'show'
            });
        },
        hideGuideCard() {
            this.isShowGuideCard = false;
        },
        showServiceNumberCard() {
            if (this.isShowServiceNumberModal) {
                return;
            }
            this.$wywLog.send({
                serverId: 17629,
                area: 'fwh',
                action: 'show',
                scene: this.guideType === 1 ? 1 : 0
            });
            this.isShowServiceNumberModal = true;
        },
        hideServiceNumberCard() {
            this.isShowServiceNumberModal = false;
        },
        // 点击授权
        handleAuthorize() {
            if (this.isSubmitting) {
                return;
            }
            this.$wywLog.send({
                serverId: 17096,
                area: 'btn-ljqyxf',
                action: 'click'
            });
            this.isSubmitting = true;
            authorize().then(() => {
                this.isShowAuthorizeSucc = true;
            }).finally(() => {
                this.isSubmitting = false;
            });
        },
        showAgentCard() {
            if (this.isShowAgentModal) {
                return;
            }
            this.isShowAgentModal = true;
        },
        hideAgentCard() {
            this.isShowAgentModal = false;
        },

        /**
         * 点击反馈
         */

        clickFeedBack() {
            this.$wywLog.send({
                serverId: 17144,
                area: 'btn-fkrk',
                action: 'click'
            });
            window.open('https://jinshuju.net/f/NjVBEh');
        },

        /**
         * 点击查看教程
         */

        watchGuide() {
            this.$wywLog.send({
                serverId: 17144,
                area: 'tjlldsjzm-btn',
                action: 'click'
            });
            window.open('https://mp.weixin.qq.com/s?__biz=MzkwNjIyODA3NQ==&mid=2247486831&idx=1&sn=2fc420d2dae8876691508b70a0873bae&chksm=c0eaf56bf79d7c7d51796d856860cbaa46064919fd476ba67d386b85362e7a7dfc45a54347b1');
        },

        /**
         * 获取二维码接口
         */

        getQrTicket() {
            this.$http.get(URL.getqrticket, {
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (!res) {
                    return;
                }
                this.serviceNumberTicket = res.qr_ticket || '';
                this.$wywLog.send({
                    serverId: 17629,
                    area: 'fwh-btn',
                    action: 'show',
                    scene: this.guideType === 1 ? 1 : 0
                });
            }).catch(err => this.$normalizeResponseError(err));
        },

        hideMask() {
            this.setGuideType('');
        },

        onServiceConfirm() {
            this.setGuideType('');
            this.hideServiceNumberCard();
        }
    }
};
</script>

<style lang="less" scoped>
.guide {
    position: fixed;
    right: 5px;
    bottom: 40px;
    z-index: 101;
    border-radius: 4px;
    border: 1px solid rgba(237, 238, 240, 1);
    box-shadow: 0 2px 6px 0 rgba(227, 233, 237, .35);
    background: #fff;
    box-sizing: border-box;
    width: 44px;

    .guide-content {
        position: relative;
        z-index: 2;
        padding-bottom: 11px;
        background: #fff;
    }

    .wise-guide {
        cursor: pointer;

        &:first-child {
            padding-top: 11px;
            border-radius: 4px 4px 0 0;
        }

        &.agent-box {
            .wise-guide-txt {
                color: #05f;
            }
        }

        .wise-guide-icon {
            margin: 0 auto 4px;
            background: url("https://lvlin-base.bj.bcebos.com/fe-saas/component/wise-guide/scan-icon.png") no-repeat;
            background-size: cover;
            width: 20px;
            height: 20px;
        }

        &.right {
            .wise-guide-icon {
                height: 16px;
                width: 18px;
                background-image: url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/right.png");
            }
        }

        &.right:hover {
            .wise-guide-txt {
                color: #a54300;
            }

            .wise-guide-icon {
                background-image: url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/right-active.png");
            }
        }

        &.feed-back {
            .wise-guide-icon {
                height: 19px;
                width: 19px;
                background-image: url("https://lvlin-base.cdn.bcebos.com/fe-saas/common/feedback.png");
            }
        }
    }

    .service-number-box {
        .service-number-icon {
            background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/wechat-service-icon.png") no-repeat;
            background-size: cover;
        }
    }
}

.wise-guide .wise-guide-icon {
    margin: 0 auto 4px;
    background: url("https://lvlin-base.bj.bcebos.com/fe-saas/component/wise-guide/scan-icon.png") no-repeat;
    background-size: cover;
    width: 20px;
    height: 20px;

    &.agent-icon {
        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/question-blue.png") no-repeat;
        background-size: cover;
        height: 18px;
        width: 18px;
    }
}

.wise-guide .wise-guide-txt {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #848691;
    text-align: center;
    line-height: 16px;
}

.wise-guide .guide-card {
    padding: 14px 17px;
    position: absolute;
    left: -161px;
    bottom: -1px;
    width: 158px;
    background: #fff;
    box-shadow: 0 2px 10px 0 rgba(20, 26, 54, .15);
    border-radius: 12px;
    text-align: center;
    cursor: default;
}

.wise-guide .guide-card::after {
    content: "";
    position: absolute;
    left: 158px;
    bottom: 0;
    width: 3px;
    height: 220px;
    background: transparent;
}

.guide-card .guide-title {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #1e1f24;
    line-height: 14px;
    font-weight: 500;
    margin-bottom: 6px;
}

.guide-card .guide-qrcode-wrap {
    background: rgb(243, 247, 255, .66);
    border: 1px solid rgba(242, 242, 242, 1);
    border-radius: 8px;
    width: 124px;
    height: 124px;
    margin: 12px 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.guide-card .guide-qrcode-wrap .guide-qrcode {
    width: 108px;
    height: 108px;
    background: url("https://lvlin-fe-saas.cdn.bcebos.com/assets/wx-qrcode-saas.png") no-repeat;
    background-size: cover;
}

.service-number-box {
    .service-number-card {
        width: 230px;
        left: -231px;
        border: 1px solid #ededed;
        padding: 24px;
        background-color: #fff;
        box-shadow: 0 5px 20px 0 #00000012;
        box-sizing: border-box;

        .card-title {
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 500;
            line-height: 18px;
            text-align: center;
        }

        .card-text {
            margin-top: 10px;
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
            color: #848691;
            text-align: center;
        }

        .card-qrcode-box {
            margin-top: 18px;

            .qrcode {
                margin: 0 auto;
                width: 182px;
                height: 182px;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
            }
        }

        .guide-msg-box {
            position: absolute;
            padding: 8px 12px 12px;
            top: 0;
            left: -234px;
            width: 224px;
            background: #05f;
            box-sizing: border-box;
            color: #fff;
            box-shadow: 0 2px 4px 0 #3855d580;
            border-radius: 4px;

            &::after {
                position: absolute;
                content: "";
                border: 5px solid transparent;
                border-left: 5px solid #05f;
                right: -10px;
                top: 50%;
                transform: translate(0, -50%);
                -webkit-transform: translate(0, -50%);
            }

            .guide-msg {
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
            }

            .confirm-btn {
                margin: 12px auto 0;
                width: 72px;
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 400;
                height: 24px;
                line-height: 24px;
                color: #f6f8f9;
                text-align: center;
                border: 1px solid #f6f8f9;
                border-radius: 4px;
            }
        }
    }
}

.guide-card .guide-txt {
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #848691;
    line-height: 12px;
}

.guide-card .watch-guide {
    color: #05f;
    cursor: pointer;
}

.line {
    height: 1px;
    background: #dbdbdb;
    margin: 10px 9px;
}

.mask-box {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: -1;
    top: 0;
    left: 0;
    background: #0009;
}
</style>